import { Project } from '../../interfaces/project.interface';
import { Department } from '../../interfaces/department.interface';
import { DesignLayer } from '../../interfaces/design-layer.interface';

export interface ProjectsStateModel {
  projects: { [key: string]: Project };
  allDepartments: Department[];
  designLayersByProjectId: { [projectId: string]: DesignLayer[] };
}

export class ListProjects {
  static readonly type = '[Project] List All In project';
  constructor(public payload: { organisationId: string }) {}
}

export class CreateProject {
  static readonly type = '[Project] Create';
  constructor(
    public payload: {
      organisationId: string;
      name: string;
      id: string;
      code: string | null;
      description: string | null;
      department_name: string | null;
      fileIds: string[];
      chief_executor_id: string | null;
    }
  ) {}
}

export class DeleteProject {
  static readonly type = '[Project] Delete';
  constructor(public payload: { organisationId: string; projectId: string }) {}
}
export class UpdateProject {
  static readonly type = '[Project] Update';
  constructor(
    public payload: {
      name: string;
      id: string;
      description: string | null;
      department_name: string | null;
      organisationId: string;
      code: string | null;
      fileIds: string[];
      chief_executor_id?: string | null;
    }
  ) {}
}

export class UpdateProjectKeepActiveDefault {
  static readonly type = '[Project] Update Keep Active Default';
  constructor(
    public payload: {
      organisationId: string;
      projectId: string;
      keepActiveDefault: boolean;
    }
  ) {}
}

export class SetUploadKeepActiveInProject {
  static readonly type = '[Project] Set Upload Keep Active';
  constructor(
    public payload: {
      projectId: string;
      uploadId: string;
      keepActive: boolean;
    }
  ) {}
}

export class CreateProjectDesign {
  static readonly type = '[Project] CreateProjectDesing';
  constructor(
    public payload: {
      organisationId: string;
      projectId: string;
      featureCollection: any;
    }
  ) {}
}

export class RenameDepartment {
  static readonly type = '[Project] Rename Department';
  constructor(
    public payload: {
      organisationId: string;
      departmentId: string;
      newName: string;
    }
  ) {}
}

export class DeleteDepartment {
  static readonly type = '[Project] Delete Department';
  constructor(
    public payload: {
      organisationId: string;
      departmentId: string;
    }
  ) {}
}

export class LoadDepartments {
  static readonly type = '[Project] Load Departments';
  constructor(public payload: { organisationId: string }) {}
}

export class LoadProjectDesignLayers {
  static readonly type = '[Project] Load Design Layers';
  constructor(public payload: { organisationId: string; projectId: string }) {}
}

export class CreateProjectDesignLayer {
  static readonly type = '[Project] Create Design Layer';
  constructor(public payload: { organisationId: string; projectId: string; name: string; color?: string }) {}
}

export class UpdateProjectDesignLayer {
  static readonly type = '[Project] Update Design Layer';
  constructor(
    public payload: { organisationId: string; projectId: string; layerId: string; name: string; color?: string }
  ) {}
}

export class DeleteProjectDesignLayer {
  static readonly type = '[Project] Delete Design Layer';
  constructor(public payload: { organisationId: string; projectId: string; layerId: string }) {}
}

export class SaveProjectDesignLayerFeatures {
  static readonly type = '[Project] Save Design Layer Features';
  constructor(public payload: { organisationId: string; projectId: string; layerId: string; featureCollection: any }) {}
}
